//import moment from 'moment';
// import momentyz from 'moment-timezone'
import store from './store'
import axios from 'axios'

//const moment = require('vue-moment');
export async function checkauth() {
  // console.log("verifica token",localStorage.getItem('token'))
  if (!localStorage.getItem('token')) {
    return false
  }

  /*var datenow = new Date().getTime();
    var dateexpired = localStorage.getItem('expired')


    if(datenow>dateexpired){
        //console.log("scaduto");
        if(localStorage.getItem('scope')=="user") {

            let url = process.env.VUE_APP_URL_API + '/auth/token'
            axios.post(url, {token:localStorage.getItem('refresh')}).then(({data}) => {
                localStorage.setItem('token', data.accessToken);
                localStorage.setItem('expired', data.expired);
                store.dispatch('settings/setToken', data.accessToken)
            });
        }else{
            //console.log("dentro")
            let url = process.env.VUE_APP_URL_API + '/auth/tokenguest'
            axios.post(url, {token:localStorage.getItem('refresh')}).then(({data}) => {
                //console.log(data)
                localStorage.setItem('token', data.accessToken);
                localStorage.setItem('expired', data.expired);

                store.dispatch('settings/setToken', data.accessToken)

            });
        }
    }*/

  return true
}
